// 261005 E4-P4b — phần dùng chung của dải "Phần mới" và nút "Duyệt & chạy tiếp" ở ②: hộp hỏi dạng promise + xử lý lỗi `append-run*`.
import React from 'react';
import { Modal, message } from 'antd';
import { appendErrorGoTo, errorText } from './appendRunView';
import type { WorkbenchTarget } from './workbenchView';

export const askConfirm = (o: { title: string; content: React.ReactNode; okText: string; danger?: boolean }): Promise<boolean> => new Promise((resolve) => {
  Modal.confirm({ title: o.title, content: o.content, okText: o.okText, cancelText: 'Thôi', okButtonProps: { danger: !!o.danger }, onOk: () => resolve(true), onCancel: () => resolve(false) });
});

/** Lỗi API `append-run*` ⇒ thông báo theo mã; `HAS_ERRORS` mở ② + liệt kê vi phạm; `OVERVIEW_NOT_EFFECTIVE` mở ② tab Tổng quan truyện (D9b); `PRE_MERGE_VERSION_GONE` (+`cancelled`) = đã huỷ nhưng không hoàn tác được. Luôn nạp lại sau đó. */
export const handleAppendError = async (e: any, deps: { goTo: (t: WorkbenchTarget) => void; refreshAll: () => Promise<unknown> }): Promise<void> => {
  const d = e?.response?.data;
  const code: string | undefined = d?.code;
  if (code === 'HAS_ERRORS') {
    const vs: Array<{ message?: string }> = Array.isArray(d?.violations) ? d.violations : [];
    deps.goTo(appendErrorGoTo(code)!);
    Modal.error({ title: 'Khung xương còn lỗi', content: (<div><p>{errorText(code, d?.message)}</p>{vs.slice(0, 8).map((v, i) => <p key={i} style={{ margin: '0 0 4px' }}>• {v.message}</p>)}</div>) });
  } else if (code === 'OVERVIEW_NOT_EFFECTIVE' || code === 'OVERVIEW_CHANGED') {
    deps.goTo(appendErrorGoTo(code)!);
    message.warning(errorText(code, d?.message), 8);
  } else if (code === 'PRE_MERGE_VERSION_GONE' && d?.cancelled) {
    message.warning(errorText(code, d?.message), 8);
  } else {
    message.error(errorText(code, d?.message), 8);
  }
  await deps.refreshAll();
};
